<template>
  <v-app>
    <NavBar />
    <v-main>
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue';
</script>

<style>
/* Global styles */
:root {
  --color-orange-primary: #F15702;
  --color-orange-secondary: #E86A2C;
  --color-brand-brown: #8C4B27;
  --color-dark-charcoal: #2d2d2d;
  --color-light-gray-bg: #f8f8f8;
  --color-white: #ffffff;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Lato', sans-serif;
  color: var(--color-dark-charcoal);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.font-heading {
  font-family: 'Cormorant Garamond', serif;
  font-weight: 700;
}

.font-body {
  font-family: 'Lato', sans-serif;
}

/* Custom color classes */
.bg-brand-orange { background-color: var(--color-orange-primary); }
.text-brand-orange { color: var(--color-orange-primary); }
.border-brand-orange { border-color: var(--color-orange-primary); }
.hover\:bg-brand-orange-dark:hover { background-color: var(--color-orange-secondary); }
.focus\:ring-brand-orange:focus { --tw-ring-color: var(--color-orange-primary); }

.text-brand-brown { color: var(--color-brand-brown); }
.bg-brand-brown { background-color: var(--color-brand-brown); }

.bg-light-gray { background-color: var(--color-light-gray-bg); }
.bg-dark-charcoal { background-color: var(--color-dark-charcoal); }

/* Card hover effect */
.card-hover-effect {
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}
.card-hover-effect:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
}

/* Hero background */
.hero-background {
  background-image: linear-gradient(rgba(45, 45, 45, 0.5), rgba(45, 45, 45, 0.5)), url('https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2511&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Section scroll margin */
section { 
  scroll-margin-top: 80px; 
}

/* Responsive utilities */
@media (max-width: 768px) {
  .hero-background {
    background-attachment: scroll;
  }
}
</style>
